import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=28b3b2a0&scoped=true"
import script from "./Main.ts?vue&type=script&lang=ts&external"
export * from "./Main.ts?vue&type=script&lang=ts&external"
import style0 from "./Main.vue?vue&type=style&index=0&id=28b3b2a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3b2a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b3b2a0')) {
      api.createRecord('28b3b2a0', component.options)
    } else {
      api.reload('28b3b2a0', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=28b3b2a0&scoped=true", function () {
      api.rerender('28b3b2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/pages/Main/Main.vue"
export default component.exports